import { useEffect, useState } from 'react';
import { useQRCode } from '../useQRCode';

type CopyTarget = 'address' | 'tag';

type CopyFeedback = CopyTarget | 'error' | null;

export const useZeroXDepositDestination = (address: string, tag: string | null) => {
  const { src: qr, isLoading: qrLoading } = useQRCode(tag ? null : address);
  const [copyFeedback, setCopyFeedback] = useState<CopyFeedback>(null);

  useEffect(() => {
    if (!copyFeedback || copyFeedback === 'error') {
      return;
    }

    const timeout = window.setTimeout(() => setCopyFeedback(null), 2_000);

    return () => window.clearTimeout(timeout);
  }, [copyFeedback]);

  const copy = async (value: string, target: CopyTarget) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopyFeedback(target);
    } catch {
      setCopyFeedback('error');
    }
  };

  return { qr, qrLoading, copyFeedback, copy };
};
